import { BufferAttribute } from 'three';

export const buildBufferAttribute = (itemSize: number, numbers: number[][]): BufferAttribute => {
  const array = new Float32Array(numbers.flat(1));
  return new BufferAttribute(array, itemSize);
};
